
import { dmApi } from "../../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../../helpers/RtkQueryUtils";
import { serialize } from "../../../helpers/Utils";


export const processingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getProcessingEmployee: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/processing-data/employees-data?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['processingEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        createProcessingEmployeeData: build.mutation({
            query: (requestBody) => {
                return {
                    url: `/processing-data/employees-data/store`,
                    method: 'POST',
                    headers: getAuthorizationHeader(),
                    body: requestBody
                };
            },
            invalidatesTags: ['processingEmployee'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Employee Data")
            },

        }),

        getProcessingSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/processing-data/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['summaryProcessing'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

        getProcessingOvenSummary: build.query({
            query: (data) => {
                let paramData = serialize(data);
                return {
                    url: `/processing-data/cooking/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['processingOvenSummary'],
            async onQueryStarted(_, { queryFulfilled, }) {
                await handleQueryError(queryFulfilled)
            },
        }),

    }),

});

export const {
    useGetProcessingEmployeeQuery,
    useCreateProcessingEmployeeDataMutation,
    useGetProcessingSummaryQuery,
    useGetProcessingOvenSummaryQuery,

} = processingApi;

